import React, { useContext, useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();
  const { user, logout } = useContext(UserContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(true);
  const navRef = useRef(null);

  const handleLogout = () => {
    logout();
    setMenuOpen(false);
    navigate('/login');
  };

  const toggleMenu = () => {
    setMenuOpen(prev => !prev);
  };

  const toggleDarkMode = () => {
    setDarkMode(prev => !prev);
  };

  // Apply dark mode on mount and when toggled
  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  }, [darkMode]);

  // Close menu on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <header className="site-header">
      <div className="header-content">
        {/* Logo */}
        <div className="logo">
          <Link to="/" onClick={() => setMenuOpen(false)}>
            <img 
              src={darkMode ? "/images/logo-dark.png" : "/images/logo-light.png"}
              alt="Book Matchup Logo"
              className="logo-full"
            />
            <img 
              src="/images/logo-48.png"
              alt="Book Symbol Logo"
              className="logo-icon"
            />
          </Link>
        </div>

        {/* Hamburger */}
        <div
          className="hamburger"
          onClick={(e) => {
            e.stopPropagation(); // prevent outside click handler
            toggleMenu();
          }}
        >
          ☰
        </div>

        {/* Navigation */}
        <nav className={`main-nav ${menuOpen ? 'open' : ''}`} ref={navRef}>
          <ul>
            <li><Link to="/" onClick={() => setMenuOpen(false)}>Home</Link></li>
            <li><Link to="/search" onClick={() => setMenuOpen(false)}>Search</Link></li>
            <li><Link to="/wishlist" onClick={() => setMenuOpen(false)}>Wishlist</Link></li>
            <li><Link to="/completed" onClick={() => setMenuOpen(false)}>Completed</Link></li>

            {user && (
              <li>
                <Link to="/private-profile" onClick={() => setMenuOpen(false)} className="profile-link">
                  Profile
                </Link>
              </li>
            )}

            {!user ? (
              <li>
                <Link to="/login" onClick={() => setMenuOpen(false)}>Login</Link>
              </li>
            ) : (
              <li>
                <button onClick={handleLogout} className="logout-btn">
                  Logout
                </button>
              </li>
            )}

            <li>
              <button
                onClick={() => {
                  toggleDarkMode();
                  setMenuOpen(false);
                }}
                className="toggle-dark-mode-btn"
              >
                {darkMode ? '☀️ Light' : '🌙 Dark'}
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
